import { Box, Divider, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import BuamaList from './BuamaList';
import { User } from './Types/Types';
interface Props {
    
};
class Users extends Component<Props, {users: User[]}> {
    constructor(props : Props) {
        super(props);
        const userStr = localStorage.getItem('users');
        this.state={
            users: JSON.parse(userStr ?? '[]'),
        };
    }
    

    componentDidMount() {
        this.load();
    }
    
    load = () => {
        axios.get<User[]>('/users')
            .then(res => {
                const users = res.data;
                localStorage.setItem('users', JSON.stringify(users));
                this.setState({
                    users: users,
                });
            });
    }

    render() {
        const { users } = this.state;
        
        const getBuamaCount = () => {
            return users.length;
        }

        return (
            <React.Fragment>
                <Box textAlign={'center'}>
                    <Typography textAlign={'center'} variant={'h4'} sx={{ p: 2, paddingBottom: 0 }}>De Duschtigstn</Typography>
                    <Typography textAlign={'center'} variant={'body2'} sx={{ p: 2, paddingTop: 0 }}>Buam und Buamarinen: {getBuamaCount()}</Typography>
                </Box>
                <Divider />
                <Box flexGrow={1} flexBasis={'400px'}>
                    <BuamaList users={users}/>
                </Box>
            </React.Fragment>
        );
    }
}
export default Users;